import React, { Component } from 'react';
class AutoTransferAppEn extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="mgt-30 faq-container">
            <div className="text-center block-title">
              <h2 className="common-title">TRIAM Auto Transfer</h2>
              <span>version: 1.0.4.1</span>
            </div>
            <div className="content">
              <section className="opening">
                <div className="intro">
                  The Auto Transfer function is a function which automatically transfers the exceed amount to another wallet when the specified coin in the specified wallet exceed the set quantity.
                  <br/>For example, you can set up as a wallet receive coin paymens from customers to prevent excessive wallet balances and increase security.
                </div>
                <div className="example">
                  <p>Example:</p>
                  <ul className="list">
                    <li>
                      <div className="text">
                        <span>① Set Auto Transfer function in the “Wallet receiving coin payments from customer”</span>
                        <span style={{ marginLeft: '25px' }}>Specified coin: RIA</span>
                        <span style={{ marginLeft: '25px' }}>Specified coin amount: 500,000RIA</span>
                        <span style={{ marginLeft: '25px' }}>Destination wallet: “Customer payment coin management wallet”</span>
                      </div>
                    </li>
                    <li>
                      <div className="text">
                        <span>② Coins will be sent from the customer to the wallet “Wallet receiving coin payments from customer”. If the balance in “Wallet receiving coin payment from customer” exceeds the specified quantity, excess coins will be automatically transferred to “Customer payment coin management wallet”.</span>
                      </div>
                    </li>
                  </ul>
                  <div className="img2">
                    <img src="/images/app/auto-transfer-des-en.png" alt="Auto Transfer Des"/>
                  </div>
                </div>
              </section>
              <hr/>
              <section className="guide guide-1">
                <h3><b>How to set up the Auto Transfer function</b></h3>
                <ul className="step-guide decimal">
                  <li>
                    <div class="content">
                      <div className="text">
                        <span>① Log in to your account and tap “Setting” on the bottom right of the menu screen. </span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s1.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>② Scroll down and tap Auto Transfer.</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s2.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>③ Tap "Setup Auto Transfer".</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s3.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>1. Wallet & Asset</b></span>
                        <span>④ Set the title, wallet selection, etc.</span>
                        <span><b>Name</b>… Enter a description of the Auto Transfer to be configured.</span>
                        <span>※It will be used as a sign when checking or changing the settings after they have been configured.</span>
                        <span><b>Source wallet</b>… Select the wallet for which you want to set the Auto Transfer function.</span>
                        <span><b>Min amount</b>… Enter the maximum quantity of the balance you wish to hold in Source wallet.</span>
                        <span><b>Asset</b>… Select the coin type.</span>
                        <span>Tap "Next" when all the input are completed.</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s4.png" alt="Auto Transfer S3"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>2. Destination & Amount</b></span>
                        <span>⑤ Select the destination wallet for coins when the Auto Transfer function is activated.</span>
                        <span><b>･Select destination from your wallets</b></span>
                        <span><b>→</b>If the wallets are in the same account, select from here.</span>
                        <span><b>･Enter the destination</b></span>
                        <span><b>→</b>Select this option for a wallet in a different account. Enter the wallet address directly.</span>
                        <span>Check the information you entered again and tap "Next".</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s5.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                    <div className="text highlight">
                      <span>※Notices:</span>
                      <span>For Destination wallet, please set a wallet that does not require Tag to be specified when receiving coins. If you set the wallet address of the exchange that requires Tag specification to Destination Wallet, the transfer process itself of Auto Transfer will be performed but please be careful because it may become an unknown deposit on the receiving side.</span>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>3. Review</b></span>
                        <span>⑥ On the next screen, you can check the flow of the set Auto Transfer function in the diagram.</span>
                        <span>Check and click NEXT button</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s6.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>4. Confirm</b></span>
                        <span>⑦ The final confirmation screen will be displayed. Confirm it and tap Confirm button.</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s7.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑧ Enter your OP password and tap Confirm</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s8.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑨ Enter Google TFA and tap Confirm</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s9.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span><b>5. Done</b></span>
                        <span>⑩ When the setting is completed, the screen on the left is displayed.</span>
                        <span>Tap Done to return to the menu screen.</span>
                        <span>The set up is now completed.</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s10.png" alt="Auto Transfer S1"/>
                      </div>
                    </div>
                  </li>
                </ul>
              </section>
              <section className="guide guide-2">
                <h3 style={{ marginBottom: '10px' }}><b>Changing the settings and procedures for the Auto Transfer function</b></h3>
                <span>You can change various settings of the Auto Transfer function.</span>
                <ul className="step-guide decimal">
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>① Tap "Settings" at the bottom right of the menu screen.</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s1.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>② Scroll down and tap Auto Transfer.</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s2.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>③ Tap the Auto Transfer you want to change.</span>
                        <span>※You will be able to identify the Auto Transfer set in Name.</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s13.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>④ This is the Auto Transfer details screen.</span>
                        <span>❶ History→You can view the coin transfer history.</span>
                        <span>❷ Edit→You can change your name, the maximum number of coins you can hold, and the destination wallet.</span>
                        <span>If you want to change the settings, tap the ❷ Edit button </span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s14.png" alt="Auto Transfer S3" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑤ You can change the title and wallet.</span>
                        <span><b>･Name</b>… If the wallets are in the same account, select from here.</span>
                        <span><b>･Select destination from your wallets</b></span>
                        <span>→If the wallets are in the same account, select from here.</span>
                        <span><b>･Enter the destination</b></span>
                        <span>→For a wallet in a different account, enter the wallet address directly here.</span>
                        <span><b>･Amount</b>… You can change the maximum number of coins you have.</span>
                        <span>Tap "Save" when all the input are completed.</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s15.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑥ Enter the OP password and tap Confirm</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s8.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑦ Enter the GoogleTFA and tap Confirm. </span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s9.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <div className="text">
                        <span>⑧ The change is completed when you switch to the screen shown on the left.</span>
                      </div>
                      <div className="img">
                        <img src="/images/app/setup-auto-transfer-s18.png" alt="Auto Transfer S1" />
                      </div>
                    </div>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AutoTransferAppEn;



// WEBPACK FOOTER //
// ./src/containers/auto-transfer-app-en.jsx